module.exports = {
  'db9ee9dv-4c99-4463-z8d0-4df1a56b3d49': {
    name: 'Tac-Tile',
    blocks: [
      // col1
      // B
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 0,
        y: 0,
        r: [0, 6, 6]
      },
      // C
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 24,
        y: 0,
        r: [0, 6, 6]
      },
      // C*
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 0,
        y: 0,
        r: [180, 24, 3]
      },
      // B
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 48,
        y: 0,
        r: [0, 6, 6]
      },

      // col2

      // E
      {
        id: 'e0b7ad2c-dd75-421f-zb29-9dde30a2157d',
        x: 0,
        y: 6,
        r: [0, 6, 6]
      },
      // F
      {
        id: 'e0b7ad2c-dd75-421f-zc29-9dde30a2157d',
        x: 0,
        y: 12,
        r: [0, 6, 6]
      },
      // A
      {
        id: 'e0b7ad2c-dd75-421f-zv19-9dde30a2157d',
        x: 12,
        y: 6,
        r: [0, 6, 6]
      },
      // C*
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 0,
        y: 9,
        r: [180, 30, 0]
      },
      // B
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 36,
        y: 9,
        r: [0, 6, 6]
      },
      // D
      {
        id: 'e0b7ad2c-dd75-421f-zv29-9dde30a2157d',
        x: 60,
        y: 6,
        r: [0, 6, 6]
      },

      // col3
      // B*
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 12,
        y: 9,
        r: [180, 6, 6]
      },
      // B
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 24,
        y: 15,
        r: [0, 6, 6]
      },
      // C*
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 60,
        y: 9,
        r: [180, 6, 6]
      },
      // C
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 48,
        y: 15,
        r: [0, 6, 6]
      },

      // col4
      // D
      {
        id: 'e0b7ad2c-dd75-421f-zv29-9dde30a2157d',
        x: 0,
        y: 21,
        r: [0, 6, 6]
      },
      // C
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 12,
        y: 21,
        r: [0, 6, 6]
      },
      // B*
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 0,
        y: 30,
        r: [180, 18, 0]
      },
      // B
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 36,
        y: 21,
        r: [0, 6, 6]
      },
      // C*
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 0,
        y: 30,
        r: [180, 30, 0]
      },
      // F
      {
        id: 'e0b7ad2c-dd75-421f-zc29-9dde30a2157d',
        x: 60,
        y: 21,
        r: [0, 6, 6]
      },
      // E
      {
        id: 'e0b7ad2c-dd75-421f-zb29-9dde30a2157d',
        x: 60,
        y: 24,
        r: [0, 6, 6]
      },

      // col5
      // B*
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 12,
        y: 24,
        r: [180, 6, 6]
      },
      // B*
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 36,
        y: 24,
        r: [180, 6, 6]
      },
      // C*
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 60,
        y: 21,
        r: [180, 6, 6]
      },
      // C
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 48,
        y: 33,
        r: [0, 6, 6]
      },

      // col6
      // F
      {
        id: 'e0b7ad2c-dd75-421f-zc29-9dde30a2157d',
        x: 0,
        y: 36,
        r: [0, 6, 6]
      },
      // E
      {
        id: 'e0b7ad2c-dd75-421f-zb29-9dde30a2157d',
        x: 0,
        y: 39,
        r: [0, 6, 6]
      },
      // A*
      {
        id: 'e0b7ad2c-dd75-421f-zv19-9dde30a2157d',
        x: 24,
        y: 33,
        r: [180, 6, 6]
      },
      // C
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 36,
        y: 36,
        r: [0, 6, 6]
      },
      // B*
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 48,
        y: 33,
        r: [180, 6, 6]
      },
      // D
      {
        id: 'e0b7ad2c-dd75-421f-zv29-9dde30a2157d',
        x: 60,
        y: 36,
        r: [0, 6, 6]
      },

      // col7
      // B*
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 12,
        y: 39,
        r: [180, 6, 6]
      },
      // C*
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 36,
        y: 36,
        r: [180, 6, 6]
      },
      // C
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 24,
        y: 48,
        r: [0, 6, 6]
      },
      // B
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 48,
        y: 45,
        r: [0, 6, 6]
      },

      // col8
      // D
      {
        id: 'e0b7ad2c-dd75-421f-zv29-9dde30a2157d',
        x: 0,
        y: 51,
        r: [0, 6, 6]
      },
      // C*
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 24,
        y: 42,
        r: [180, 6, 6]
      },
      // B
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 12,
        y: 54,
        r: [0, 6, 6]
      },
      // A
      {
        id: 'e0b7ad2c-dd75-421f-zv19-9dde30a2157d',
        x: 36,
        y: 51,
        r: [0, 6, 6]
      },
      // F
      {
        id: 'e0b7ad2c-dd75-421f-zc29-9dde30a2157d',
        x: 60,
        y: 51,
        r: [0, 6, 6]
      },
      // E
      {
        id: 'e0b7ad2c-dd75-421f-zb29-9dde30a2157d',
        x: 60,
        y: 54,
        r: [0, 6, 6]
      },

      // col9
      // B*
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 12,
        y: 54,
        r: [180, 6, 6]
      },
      // C
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 24,
        y: 60,
        r: [0, 6, 6]
      },
      // C*
      {
        id: 'e0b7ad2c-dd75-421f-zc39-9dde30a2157d',
        x: 36,
        y: 54,
        r: [180, 6, 6]
      },
      // B*
      {
        id: 'e0b7ad2c-dd75-421f-zb19-9dde30a2157d',
        x: 60,
        y: 54,
        r: [180, 6, 6]
      }

    ],
    repeat: [
      [0, 66],
      [72, 0]
    ],
    changeViewport: [1]
    //  origin: [0, 1],
    // align: [
    //   [12, -6, 0, 0]
    // ],

  },
  'db9ee9da-4c99-4463-a8d0-4df1a56b3d49': {
    name: 'Square-001',
    blocks: [{ id: '4e2bec82-17b4-426a-91a3-465110a9f053' }],
    repeat: [[12, 0], [0, 12]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '6a5207be-6f0f-4312-928e-75b4bb3993f9': {
    name: 'Square-002',
    blocks: [{ id: '4e2bec82-17b4-426a-91a3-465110a9f053' }],
    repeat: [[12, 0], [6, 12]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '3e6890ba-20ef-4634-9d67-f2d5c9e6573c': {
    name: 'Rectangle-001',
    blocks: [{ id: '43f6902a-d03c-4d36-af81-f38d2e2405c9' }],
    repeat: [[24, 0], [0, 8]],
    origin: [0.5, 0],
    align: [[24, -12, -24, 0]]
  },

  '85663125-89d4-4c2e-ac20-6b08d9c458c9': {
    name: 'Rectangle-002',
    blocks: [{ id: '43f6902a-d03c-4d36-af81-f38d2e2405c9' }],
    repeat: [[24, 0], [12, 8]],
    origin: [0.5, 0],
    align: [[24, -12, -24, 0]]
  },

  '797adb6d-e545-4cd3-9421-b5953580b70b': {
    name: 'Rectangle-003',
    blocks: [{ id: '347dca8d-682a-4782-8974-f86eb4f54265' }],
    repeat: [[12, 0], [0, 8]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '518c8c2f-f362-4e0c-81d7-c2e971f37838': {
    name: 'Rectangle-004',
    blocks: [{ id: '347dca8d-682a-4782-8974-f86eb4f54265' }],
    repeat: [[12, 0], [6, 8]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  'b82401a7-1657-4c1a-b998-dfdf5d35cc87': {
    name: 'Rectangle-008',
    blocks: [
      {
        id: '347dca8d-682a-4782-8974-f86eb4f54265',
        x: -2,
        y: 2,
        r: [90, 6, 4]
      },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 8, r: [90, 6, 6] },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 8, r: [270, 6, 6] },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 20, r: [90, 6, 6] },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 20, r: [270, 6, 6] },
      {
        id: '43f6902a-d03c-4d36-af81-f38d2e2405c9',
        x: 24,
        y: 8,
        r: [90, 12, 4]
      },
      { id: '4e2bec82-17b4-426a-91a3-465110a9f053', x: 40 },
      {
        id: '347dca8d-682a-4782-8974-f86eb4f54265',
        x: 50,
        y: 2,
        r: [90, 6, 4]
      },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 60 },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 60, r: [180, 6, 6] },

      { id: '4e2bec82-17b4-426a-91a3-465110a9f053', y: 12 },
      {
        id: '43f6902a-d03c-4d36-af81-f38d2e2405c9',
        x: 4,
        y: 20,
        r: [90, 12, 4]
      },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 20,
        y: 12,
        r: [90, 6, 6]
      },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 20,
        y: 12,
        r: [270, 6, 6]
      },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 40,
        y: 12,
        r: [90, 6, 6]
      },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 40,
        y: 12,
        r: [270, 6, 6]
      },
      {
        id: '347dca8d-682a-4782-8974-f86eb4f54265',
        x: 50,
        y: 14,
        r: [90, 6, 4]
      },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 60,
        y: 12,
        r: [90, 6, 6]
      },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 60,
        y: 12,
        r: [270, 6, 6]
      },

      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', y: 24, r: [90, 6, 6] },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', y: 24, r: [270, 6, 6] },
      {
        id: '347dca8d-682a-4782-8974-f86eb4f54265',
        x: 18,
        y: 26,
        r: [90, 6, 4]
      },
      {
        id: '347dca8d-682a-4782-8974-f86eb4f54265',
        x: 26,
        y: 26,
        r: [90, 6, 4]
      },
      { id: '4e2bec82-17b4-426a-91a3-465110a9f053', x: 36, y: 24 },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 48,
        y: 24,
        r: [90, 6, 6]
      },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 48,
        y: 24,
        r: [270, 6, 6]
      },
      { id: '4e2bec82-17b4-426a-91a3-465110a9f053', x: 60, y: 24 },

      {
        id: '347dca8d-682a-4782-8974-f86eb4f54265',
        x: -2,
        y: 38,
        r: [90, 6, 4]
      },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 8, y: 36 },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 8,
        y: 36,
        r: [180, 6, 6]
      },
      {
        id: '347dca8d-682a-4782-8974-f86eb4f54265',
        x: 18,
        y: 38,
        r: [90, 6, 4]
      },
      {
        id: '347dca8d-682a-4782-8974-f86eb4f54265',
        x: 26,
        y: 38,
        r: [90, 6, 4]
      },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 36, y: 36 },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 36,
        y: 36,
        r: [180, 6, 6]
      },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 48,
        y: 36,
        r: [90, 6, 6]
      },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 48,
        y: 36,
        r: [270, 6, 6]
      },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 60, y: 36 },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 60,
        y: 36,
        r: [180, 6, 6]
      }
    ],
    repeat: [[72, 0], [0, 48]],
    origin: [0.5, 0]
  },

  '1de33837-dcd9-4343-afa0-dd8bf784d526': {
    name: 'Triangle 60-001',
    blocks: [
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6' },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 6.875,
        r: [180, 6.875, 6]
      }
    ],
    repeat: [[13.75, 0], [0, 12]],
    origin: [0.5, 0]
  },

  'b77bce77-af3c-49a2-94b3-a3b667fa60df': {
    name: 'Triangle 60-002',
    blocks: [
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6' },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 6.875,
        r: [180, 6.875, 6]
      }
    ],
    repeat: [[13.75, 0], [6.875, 12]],
    origin: [0.5, 0]
  },

  '20cb340b-5ee8-41a0-b8a9-ab8c5f0c001a': {
    name: 'Triangle 90-001',
    blocks: [
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d' },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', r: [180, 6, 6] }
    ],
    repeat: [[12, 0], [0, 12]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '0bf4f536-32d8-4fb1-a6f8-3e2a59ef90a8': {
    name: 'Triangle 90-002',
    blocks: [
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', r: [90, 6, 6] },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', r: [270, 6, 6] }
    ],
    repeat: [[12, 0], [0, 12]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '253b803f-93ce-4f6b-a58b-3d87c678a55b': {
    name: 'Triangle 90-003',
    blocks: [
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d' },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', r: [180, 6, 6] },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 12, r: [90, 6, 6] },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 12, r: [270, 6, 6] },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', y: 12, r: [90, 6, 6] },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', y: 12, r: [270, 6, 6] },
      { id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d', x: 12, y: 12 },
      {
        id: 'e0b7ad2c-dd75-421f-a639-9dde30a2157d',
        x: 12,
        y: 12,
        r: [180, 6, 6]
      }
    ],
    repeat: [[24, 0], [0, 24]],
    origin: [0.5, 0],
    align: [[12, -6, -12, 0]]
  },

  '96640d3b-311c-49c2-b06e-37d2b79d0d65': {
    name: 'Diamond-001',
    blocks: [{ id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba' }],
    repeat: [[13.75, 0], [6.875, 12]],
    origin: [0.5, 0],
    align: [[13.75, -6.875, -13.75, 0]]
  },

  'a78e4911-e6b1-4cc9-a9e8-e969671a1bd9': {
    name: 'Diamond-002',
    blocks: [
      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba' },
      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', r: [59.9, 6.875, 0] },
      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', r: [-59.9, 6.875, 24] }
    ],
    repeat: [[20.705, 12], [0, 24]],
    origin: [0.5, 0]
  },

  'deb17540-1c21-450e-adde-b09fc709b4b3': {
    name: 'Diamond-003',
    blocks: [
      {
        id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba',
        x: -6.875,
        y: -12,
        r: [90, 6.875, 12]
      },
      {
        id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba',
        x: -12.875,
        y: -1.69,
        r: [149.9, 6.875, 12]
      },
      {
        id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba',
        x: -0.875,
        y: -1.69,
        r: [-149.9, 6.875, 12]
      }
    ],
    repeat: [[24, 0], [12, 20.7]],
    origin: [0.5, 0]
  },

  '7ada7f48-254f-4fae-af61-6739bc3dccf6': {
    name: 'Diamond-004',
    blocks: [
      // row 1
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 6.875,
        r: [180, 6.875, 6]
      },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 20.625,
        r: [180, 6.875, 6]
      },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 34.375,
        r: [180, 6.875, 6]
      },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 48.125,
        r: [180, 6.875, 6]
      },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 61.875,
        r: [180, 6.875, 6]
      },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 75.625,
        r: [180, 6.875, 6]
      },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 89.375,
        r: [180, 6.875, 6]
      },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 103.125,
        r: [180, 6.875, 6]
      },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 116.875,
        r: [180, 6.875, 6]
      },

      // row 2
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6' },
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', y: 12, r: [180, 6.875, 6] },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 13.75 },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 27.5 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 27.5,
        y: 12,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 41.25 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 41.25,
        y: 12,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 55 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 55,
        y: 12,
        r: [180, 6.875, 6]
      },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 68.75 },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 82.5 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 82.5,
        y: 12,
        r: [180, 6.875, 6]
      },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 96.25 },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 110 },

      // row 3
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 6.875, y: 12 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 6.875,
        y: 24,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 20.625, y: 12 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 20.625,
        y: 24,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 34.375, y: 12 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 34.375,
        y: 24,
        r: [180, 6.875, 6]
      },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 48.125, y: 12 },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 61.875, y: 12 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 61.875,
        y: 24,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 75.625, y: 12 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 75.625,
        y: 24,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 89.375, y: 12 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 89.375,
        y: 24,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 103.125, y: 12 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 103.125,
        y: 24,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 116.875, y: 12 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 116.875,
        y: 24,
        r: [180, 6.875, 6]
      },

      // row 4
      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', y: 24 },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 13.75, y: 24 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 13.75,
        y: 36,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 27.5, y: 24 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 27.5,
        y: 36,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 41.25, y: 24 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 41.25,
        y: 36,
        r: [180, 6.875, 6]
      },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 55, y: 24 },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 68.75, y: 24 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 68.75,
        y: 36,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 82.5, y: 24 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 82.5,
        y: 36,
        r: [180, 6.875, 6]
      },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 96.25, y: 24 },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 110, y: 24 },
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 110, y: 24 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 110,
        y: 36,
        r: [180, 6.875, 6]
      },

      // row 5
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 6.875, y: 36 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 6.875,
        y: 48,
        r: [180, 6.875, 6]
      },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 20.625, y: 36 },
      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 34.375, y: 36 },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 48.125, y: 36 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 48.125,
        y: 48,
        r: [180, 6.875, 6]
      },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 61.875, y: 36 },
      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 75.625, y: 36 },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 89.375, y: 36 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 89.375,
        y: 48,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 103.125, y: 36 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 103.125,
        y: 48,
        r: [180, 6.875, 6]
      },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 116.875, y: 36 },

      // row 6
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', y: 48 },
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', y: 60, r: [180, 6.875, 6] },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 13.75, y: 48 },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 27.5, y: 48 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 27.5,
        y: 60,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 41.25, y: 48 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 41.25,
        y: 60,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 55, y: 48 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 55,
        y: 60,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 68.75, y: 48 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 68.75,
        y: 60,
        r: [180, 6.875, 6]
      },

      { id: 'a82c43f6-a855-40c7-82c3-c25f2db5e5ba', x: 82.5, y: 48 },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 96.25, y: 48 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 96.25,
        y: 60,
        r: [180, 6.875, 6]
      },

      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 110, y: 48 },
      {
        id: '840ad52b-d579-4233-ba31-ca81de9f34c6',
        x: 110,
        y: 60,
        r: [180, 6.875, 6]
      },

      // row 7
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 6.875, y: 60 },
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 20.625, y: 60 },
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 34.375, y: 60 },
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 48.125, y: 60 },
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 61.875, y: 60 },
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 75.625, y: 60 },
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 89.375, y: 60 },
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 103.125, y: 60 },
      { id: '840ad52b-d579-4233-ba31-ca81de9f34c6', x: 116.875, y: 60 }
    ],
    repeat: [[123.75, 0], [0, 72]],
    origin: [0.5, 0]
  },

  '844a3bc5-f148-41c7-a0c0-6dc3cc8523f7': {
    name: 'Hex-001',
    blocks: [{ id: 'c8ff74cd-20a5-46c3-856c-325a910bdb27' }],
    repeat: [[10.375, 6], [0, 12]],
    origin: [0.5, 0]
  },

  'c66207c3-850a-4e68-864e-d0b766f92235': {
    name: 'ARO 1-001',
    dimensions: { i: `W 1'-0 3/4" x H 11"`, m: 'W 32 cm x H 28 cm' },
    blocks: [
      { id: '6fa2d74f-655b-414b-b282-422b21e544b2' },
      {
        id: '6fa2d74f-655b-414b-b282-422b21e544b2',
        x: 6.9785,
        r: [180, 6.9785, 6.045]
      }
    ],
    repeat: [[13.957, 0], [6.9785, 12.09]],
    origin: [0.5, 0]
  },

  'e6d8fc9e-91c3-43bb-9151-9c3cbbd5b7f5': {
    name: 'ARO 2-001',
    dimensions: { i: `W 10 3/4” x H 9 1/4”`, m: 'W 27.4 cm x H 23.7 cm' },
    blocks: [
      { id: 'e8a69811-3dfb-4db2-b9c5-e7f22891ee9b' },
      {
        id: 'e8a69811-3dfb-4db2-b9c5-e7f22891ee9b',
        x: 6.86295,
        r: [180, 6.86295, 5.941355]
      }
    ],
    repeat: [[13.7259, 0], [6.9785, 11.88271]],
    origin: [0.5, 0],
    preview: {
      width: 70.5,
      height: 47
    }
  },

  '8a2e7abe-f73b-496a-a55c-795a6939d025': {
    name: 'ARO 3-001',
    dimensions: { i: `W 1’-6” 3/4” x H 8”`, m: 'W 45.7 cm x H 20.3 cm' },
    blocks: [{ id: '700039ec-4130-4d93-9212-39c57640f8df', y: -4.5 }],
    repeat: [[16.75, 0], [8.25, 7]],
    origin: [0.5, 0]
  },

  '18f8377e-4196-477c-9ae6-95639f53bf54': {
    name: 'ARO 4-001',
    dimensions: { i: `W 1’-9 3/4” x H 7 3/4”`, m: 'W 55.2 cm x H 19.7 cm' },
    blocks: [{ id: '0da46e9a-8c97-4977-9712-57870c8f1f94' }],
    repeat: [[20.25, 0], [-1.5, 7.75]],
    origin: [0.5, 0],
    preview: {
      width: 69,
      height: 46
    }
  },

  '6057b2f8-fed0-4a0f-b379-cbc80d05ff85': {
    name: 'ARO 4-002',
    dimensions: { i: `W 1’-4” x H 7 3/4”`, m: 'W 40.4 cm x H 19.7 cm' },
    blocks: [{ id: '982a1c91-0a01-4630-b8fd-886b29fabb21' }],
    repeat: [[14.5, 0], [-1.5, 7.75]],
    origin: [0.5, 0],
    preview: {
      width: 69,
      height: 46
    }
  },

  '6dba90ab-3c65-4f8d-8c1a-ff384af4d265': {
    name: 'ARO 4-003',
    blocks: [
      { id: '982a1c91-0a01-4630-b8fd-886b29fabb21' },
      { id: '0da46e9a-8c97-4977-9712-57870c8f1f94', x: 14.5 },
      { id: '0da46e9a-8c97-4977-9712-57870c8f1f94', x: -1.5, y: 7.75 },
      { id: '982a1c91-0a01-4630-b8fd-886b29fabb21', x: 18.75, y: 7.75 }
    ],
    repeat: [[34.75, 0], [-3, 15.5]],
    origin: [0.5, 0],
    preview: {
      width: 69,
      height: 46
    }
  },

  '6ebdd50f-4760-4a5d-a746-4da9d1147d18': {
    name: 'Bottle-001',
    blocks: [
      { id: '679b38fa-ad4d-4382-b53c-80ab3ba70c0d' },
      {
        id: '679b38fa-ad4d-4382-b53c-80ab3ba70c0d',
        x: 1.42,
        y: 1.42,
        r: [90, 0, 0]
      }
    ],
    repeat: [[9.2 * 2, 0], [9.2, 9.2]],
    origin: [0.5, 0],
    align: [[9.2, -4.6, -4.6, 0]]
  },

  'da8a8310-7e8b-4875-b172-d8f6c0e1515c': {
    name: 'Fish-001',
    blocks: [{ id: '6e1bccce-613a-43ce-9d87-7324b33b6cfa' }],
    origin: [0.5, 0],
    repeat: [[10.82, 0], [5.385, 4.254]],
    align: [[12, -1.18, -1.18, 0]]
  },

  '776b4083-b29f-49b6-bfaf-0ac81f21ea4a': {
    name: 'Fish-002',
    blocks: [
      { id: '6e1bccce-613a-43ce-9d87-7324b33b6cfa', r: [-90, 0, 0], y: 12 }
    ],
    origin: [0.5, 0],
    repeat: [[4.254, 5.385], [0, 10.82]],
    align: [[6.427, -6.427 / 2, -6.427 / 2, 0]]
  },

  'd090aed0-4eec-445f-b7d0-d242ff84e5e4': {
    name: 'Fish-003',
    blocks: [
      {
        id: '6e1bccce-613a-43ce-9d87-7324b33b6cfa',
        r: [-180, 0, 0],
        x: 12,
        y: 6.427
      }
    ],
    origin: [0.5, 0],
    repeat: [[10.82, 0], [5.385, 4.254]],
    align: [[12, -1.18, -1.18, 0]]
  },

  'f37c6ad0-6b61-4197-bba6-49a001f7fe1f': {
    name: 'Fish-004',
    blocks: [
      { id: '6e1bccce-613a-43ce-9d87-7324b33b6cfa', r: [90, 0, 0], x: 6.427 }
    ],
    origin: [0.5, 0],
    repeat: [[4.254, 5.385], [0, 10.82]],
    align: [[6.427, -6.427 / 2, -6.427 / 2, 0]]
  },

  'fb68821e-a705-49da-82a7-4821a27f4bcc': {
    name: 'Goblet-001',
    blocks: [
      { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9' },
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [180, 0, 0],
        x: 5.625 + 3.612,
        y: 12
      }
    ],
    origin: [0.5, 0],
    repeat: [[5.625 + 3.612 - 2.25, 0], [0, 12]],
    align: [[5.625 + 3.612, -(5.625 + 3.612) / 2, -(5.625 + 3.612) / 2, 0]]
  },

  'ba95ba12-eb89-45cc-a81a-c0b16ce466b2': {
    name: 'Goblet-002',
    blocks: [
      { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9' },
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [180, 0, 0],
        x: 5.625 + 3.612,
        y: 12
      }
    ],
    origin: [0.5, 0],
    repeat: [[5.625 + 3.612 - 2.25, 0], [3.54, 12]],
    align: [[5.625 + 3.612, -(5.625 + 3.612) / 2, -(5.625 + 3.612) / 2, 0]]
  },

  '8e9bdb36-b588-462d-aecd-d1f6769cba64': {
    name: 'Goblet-003',
    blocks: [
      { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9' },
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [180, 0, 0],
        x: 5.625 + 3.612,
        y: 12
      },
      // second row
      { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: -3.54 + 0.75, y: 12 },
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [180, 0, 0],
        x: -3.54 + 0.75 + 5.625 + 3.612,
        y: 24
      }
    ],
    origin: [0.5, 0],
    repeat: [[5.625 + 3.612 - 2.25, 0], [0, 24]],
    align: [[5.625 + 3.612, -(5.625 + 3.612) / 2, -(5.625 + 3.612) / 2, 0]]
  },

  '89824802-8bc2-4081-ae5c-c23c35513078': {
    name: 'Goblet-004',
    blocks: [
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [90, 0, 0],
        x: 12,
        y: -5.625 / 2
      },
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [-90, 0, 0],
        y: 5.625 / 2 + 3.612
      }
    ],
    origin: [0.5, 0],
    repeat: [[12, 0], [0, 5.625 + 3.612 - 2.25]],
    align: [[12, -6, -12, 0]]
  },

  'bca9a8ac-2f63-4a89-8754-cd8238b8a3e2': {
    name: 'Goblet-005',
    origin: [0.5, 0],
    blocks: [
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [180, 0, 0],
        x: 5.685,
        y: 12
      },
      { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 3.575, y: 0 },
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [180, 0, 0],
        x: 12.935,
        y: 12
      },
      { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 10.825, y: 0 },
      {
        id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
        r: [180, 0, 0],
        x: 22.375,
        y: 12
      },
      { id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: 20.375, y: 0 },
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [180, 0, 0],
        x: 31.935,
        y: 12
      },
      { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 29.825, y: 0 },
      {
        id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
        r: [180, 0, 0],
        x: 41.375,
        y: 12
      },
      { id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: 39.375, y: 0 },
      { id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: 0, y: 12 },
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [180, 0, 0],
        x: 11.56,
        y: 24
      },
      { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 9.45, y: 12 },
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [180, 0, 0],
        x: 18.81,
        y: 24
      },
      { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 16.7, y: 12 },
      {
        id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
        r: [180, 0, 0],
        x: 28.25,
        y: 24
      },
      { id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: 26.25, y: 12 },
      {
        id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9',
        r: [180, 0, 0],
        x: 37.81,
        y: 24
      },
      { id: '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9', x: 35.7, y: 12 },
      {
        id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
        r: [180, 0, 0],
        x: 47.25,
        y: 24
      }
    ],
    repeat: [[45.25, 0], [0, 24]],
    align: [[1, -1, -1, 0]]
  },

  'e75bce1f-439c-4a74-8bb9-f22a49997f9d': {
    name: 'Hourglass-001',
    blocks: [{ id: '036da44e-0a01-4c91-a15d-2e25a63e916c', x: -6, y: -6 }],
    origin: [0.5, 0],
    repeat: [[7.435, 6], [0, 12]]
  },

  '7b151173-0151-4366-bd68-fcc61977fda7': {
    name: 'Hourglass-002',
    blocks: [
      {
        id: '036da44e-0a01-4c91-a15d-2e25a63e916c',
        r: [-90, 0, 0],
        x: -6,
        y: 6
      }
    ],
    origin: [0.5, 0],
    repeat: [[12, 0], [6, 7.435]]
  },

  'a862e78a-ba55-4943-96a7-6bf6b8d76e1e': {
    name: 'Spindle-001',
    blocks: [{ id: 'deea6070-c7cd-4509-8467-5292853e611b', x: -3.5, y: -6 }],
    origin: [0.5, 0],
    repeat: [[4.1, 6], [0, 12]]
  },

  '0d4450cd-f869-43ae-a8ff-cbda10040b81': {
    name: 'Spindle-002',
    blocks: [
      {
        id: 'deea6070-c7cd-4509-8467-5292853e611b',
        r: [-90, 0, 0],
        x: -6,
        y: 3.5
      }
    ],
    origin: [0.5, 0],
    repeat: [[12, 0], [6, 4.1]]
  },

  '30c72f7c-7680-4560-8223-fad2965d0e5a': {
    name: 'Vase-001',
    blocks: [
      { id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: -1.02 },
      {
        id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
        r: [180, 0, 0],
        x: 1.02,
        y: 12
      }
    ],
    origin: [0.5, 0],
    repeat: [[11.6, 0], [0, 12]]
  },

  'd1df5ebe-ab3d-4912-b124-e60f65f719b9': {
    name: 'Vase-002',
    blocks: [
      { id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: -1.02 },
      {
        id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
        r: [180, 0, 0],
        x: 1.02,
        y: 12
      }
    ],
    origin: [0.5, 0],
    repeat: [[11.6, 0], [5.8, 12]]
  },

  '96cc0040-b9a0-4c84-ae3c-4f519791a0e6': {
    name: 'Vase-003',
    blocks: [
      { id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558', x: -1.02 },
      {
        id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
        r: [180, 0, 0],
        x: 1.02,
        y: 12
      },
      // second row
      {
        id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
        x: 5.8 - 1.02 - 1.8,
        y: 12
      },
      {
        id: 'd69f96d6-5561-4199-bf23-1c8ccbb29558',
        r: [180, 0, 0],
        x: 5.8 + 1.02 - 1.8,
        y: 24
      }
    ],
    origin: [0.5, 0],
    repeat: [[11.6, 0], [0, 24]]
  },

  '403560ac-4a5a-4219-b7cf-01e0114d4eae': {
    name: 'Chevron-001',
    blocks: [
      { id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d' },
      { id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b', x: 12 }
    ],
    origin: [0.5, 0],
    repeat: [[24, 0], [0, 6]],
    align: [[24, -12, 0, 0]]
  },

  'cd3f3c70-eb93-4c9a-bf78-4f1f530204ee': {
    name: 'Chevron-002',
    blocks: [
      { id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b' },
      { id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d', x: 12 }
    ],
    origin: [0.5, 0],
    repeat: [[24, 0], [0, 6]],
    align: [[24, -12, 0, 0]]
  },

  '715d6e16-20e7-4b97-8a69-c0227e922751': {
    name: 'Chevron-003',
    blocks: [
      { id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b', r: [90, 12, 0], y: 12 },
      {
        id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d',
        r: [90, 0, 0],
        x: 12,
        y: 12
      }
    ],
    origin: [0.5, 0],
    repeat: [[6, 0], [0, 24]],
    align: [[1, -6, -6, 0]]
  },

  'f3cdd2a4-da8a-447e-9687-dad9ec6b7809': {
    name: 'Chevron-004',
    blocks: [
      { id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d', r: [90, 12, 0], y: 12 },
      {
        id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b',
        r: [90, 0, 0],
        x: 12,
        y: 12
      }
    ],
    origin: [0.5, 0],
    repeat: [[6, 0], [0, 24]],
    align: [[1, -6, -6, 0]]
  },

  '8e7f6f31-43ce-4713-a65d-24e98b5b3d9a': {
    name: 'Chevron-005',
    blocks: [{ id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b' }],
    origin: [0.5, 0],
    repeat: [[12, 0], [0, 6]],
    align: [[12, -6, 0, 0]]
  },

  'b6ee4df2-57bc-4499-9bcb-8c885e53efb1': {
    name: 'Chevron-006',
    blocks: [{ id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d' }],
    origin: [0.5, 0],
    repeat: [[12, 0], [0, 6]],
    align: [[12, -6, 0, 0]]
  },

  '2130a6b2-2284-4100-bd3b-8ec9f34627a2': {
    name: 'Chevron-007',
    blocks: [
      { id: '994f1c2b-3548-42dd-b792-e5c5e9e42e1d', r: [90, 0, 0], x: 12 }
    ],
    origin: [0.5, 0],
    repeat: [[6, 0], [0, 12]],
    align: [[1, -6, -6, 0]]
  },

  '61870097-d969-4970-9892-17744dbd74b7': {
    name: 'Chevron-008',
    blocks: [
      { id: 'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b', r: [90, 0, 0], x: 12 }
    ],
    origin: [0.5, 0],
    repeat: [[6, 0], [0, 12]],
    align: [[1, -6, -6, 0]]
  },

  'b05cd8de-8e0a-4a93-b497-cd576c58fb21': {
    name: 'Dart-001',
    blocks: [{ id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d' }],
    origin: [0.5, 0],
    repeat: [[10, 0], [0, 10]],
    align: [[10, -5, 0, 0]],
    preview: {
      width: 75,
      height: 50
    }
  },

  'bb1c7900-cc21-40bb-8933-1c5bac5246f2': {
    name: 'Dart-002',
    blocks: [
      {
        id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d',
        r: [180, 0, 0],
        x: 10,
        y: 15
      }
    ],
    origin: [0.5, 0],
    repeat: [[10, 0], [0, 10]],
    align: [[10, -5, 0, 0]],
    preview: {
      width: 75,
      height: 50
    }
  },

  '312d2987-67b5-419b-81a4-42d087aad947': {
    name: 'Dart-003',
    blocks: [
      { id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d', r: [90, 0, 0], x: 12.5 }
    ],
    origin: [0.5, 0],
    repeat: [[10, 0], [0, 10]],
    preview: {
      width: 75,
      height: 50
    }
  },

  '9430fb63-4bac-41d2-afc0-faedbc9f4ec4': {
    name: 'Dart-004',
    blocks: [
      {
        id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d',
        r: [-90, 0, 0],
        x: -12.5,
        y: 10
      }
    ],
    origin: [0.5, 0],
    repeat: [[10, 0], [0, 10]],
    preview: {
      width: 75,
      height: 50
    }
  },

  'a23001a8-128f-49ea-bdcd-25fc2b7317cd': {
    name: 'Dart-005',
    blocks: [
      { id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d' },
      {
        id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d',
        r: [180, 0, 0],
        x: 20,
        y: 15
      }
    ],
    origin: [0.5, 0],
    repeat: [[20, 0], [0, 10]],
    align: [[20, -10, 0, 0]],
    preview: {
      width: 75,
      height: 50
    }
  },

  'fd3cd5cc-ed24-4aa7-9a9e-2a82248b5747': {
    name: 'Dart-006',
    blocks: [
      { id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d' },
      {
        id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d',
        r: [180, 0, 0],
        x: 20,
        y: 15
      },
      {
        id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d',
        r: [180, 0, 0],
        x: 30,
        y: 15
      }
    ],
    origin: [0.5, 0],
    repeat: [[30, 0], [0, 10]],
    align: [[20, -10, 0, 0]],
    preview: {
      width: 75,
      height: 50
    }
  },

  'ddd07a1e-8116-42b5-bd9e-79fd7853726f': {
    name: 'Dart-007',
    blocks: [
      { id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d', r: [-45, 5, 0], x: -5 }
    ],
    origin: [0.5, 0],
    repeat: [[Math.sqrt(50), Math.sqrt(50)], [-Math.sqrt(50), Math.sqrt(50)]],
    preview: {
      width: 78,
      height: 52
    }
  },

  '97abd38a-eb6c-491d-86f7-c4bd66a851b4': {
    name: 'Dart-008',
    blocks: [
      { id: '0d5ebc31-8892-4471-a6d6-bb13ee6a932d', r: [45, 5, 0], x: -5 }
    ],
    origin: [0.5, 0],
    repeat: [[Math.sqrt(50), Math.sqrt(50)], [-Math.sqrt(50), Math.sqrt(50)]],
    preview: {
      width: 78,
      height: 52
    }
  },

  '5649feec-e25b-4a8f-a515-8a62b580c6aa': {
    name: 'Picket-001',
    blocks: [{ id: '854ce8f3-c736-4998-9b35-8d874c0bd420' }],
    origin: [0.5, 0],
    repeat: [[5.8564, 0], [2.9282, 10.9282]],
    preview: {
      width: 75,
      height: 50
    }
  },

  '7e01dd9f-bd6c-4216-aff0-db7c442c6d74': {
    name: 'Picket-002',
    blocks: [
      { id: '854ce8f3-c736-4998-9b35-8d874c0bd420', r: [90, 0, 0], x: 8 }
    ],
    origin: [0.5, 0],
    repeat: [[10.9282, 2.9282], [0, 5.8564]]
  },

  'f88cac62-245c-47c0-b1e0-45af730fe08a': {
    name: 'Picket-003',
    blocks: [
      { id: '854ce8f3-c736-4998-9b35-8d874c0bd420', r: [15, 2.9282, 0] },
      {
        id: '854ce8f3-c736-4998-9b35-8d874c0bd420',
        r: [-15, 2.9282, 0],
        x: 1.53,
        y: 5.58
      }
    ],
    origin: [0.5, 0],
    repeat: [[11.37, 0], [0, 11.2]],
    align: [[1, -3.75, -3.75, 0]]
  },

  '40ad5a09-92c6-4324-84d0-c037f8ccdd29': {
    name: 'Picket-004',
    blocks: [
      { id: '854ce8f3-c736-4998-9b35-8d874c0bd420', r: [255, 2.9282, 0] },
      {
        id: '854ce8f3-c736-4998-9b35-8d874c0bd420',
        r: [-255, 2.9282, 0],
        x: 9.76,
        y: 5.64
      }
    ],
    origin: [0.5, 0],
    repeat: [[11.37, 0], [0, 11.2]],
    align: [[1, -3.75, -3.75, 0], [1, 2.4, 2.4, 0]],
    preview: {
      width: 75,
      height: 50
    }
  },

  '0fe9c5b8-db53-473c-b1f9-3e65351c4198': {
    name: 'Plus-001',
    blocks: [{ id: 'c85a3088-adef-4e09-87a4-ad827ce8ea61', x: -10 }],
    origin: [0.5, 0],
    repeat: [[8, -4], [4, 8]]
  },

  '6938f1f4-f01f-4fa1-9f95-7baaa5f068aa': {
    name: 'Plus-002',
    blocks: [{ id: 'c85a3088-adef-4e09-87a4-ad827ce8ea61', x: -2 }],
    origin: [0.5, 0],
    repeat: [[8, 4], [-4, 8]]
  },

  'f63506bd-8e58-4e57-856c-02713cd7b319': {
    name: 'Plus-003',
    blocks: [
      { id: 'c85a3088-adef-4e09-87a4-ad827ce8ea61', r: [45, 4, 0], x: -4 }
    ],
    origin: [0.5, 0],
    repeat: [
      [1.5 * Math.sqrt(32), -16 / Math.sqrt(32)],
      [16 / Math.sqrt(32), 1.5 * Math.sqrt(32)]
    ]
  },

  '3f92d800-eac3-4761-ad57-113513a77659': {
    name: 'Plus-004',
    blocks: [
      { id: 'c85a3088-adef-4e09-87a4-ad827ce8ea61', r: [45, 4, 0], x: 2 }
    ],
    origin: [0.5, 0],
    repeat: [
      [1.5 * Math.sqrt(32), 16 / Math.sqrt(32)],
      [-16 / Math.sqrt(32), 1.5 * Math.sqrt(32)]
    ]
  },

  'be3ee6b5-32fc-43ca-aa1d-d9a6919cfc70': {
    name: 'Scale Small',
    dimensions: {
      i: `W 5 1/2” x H 5 11/16”`,
      m: 'W 14 cm x H 14.5 cm',
      w: 14,
      h: 14.5
    },
    fullBlocksOnly: true,
    blocks: [
      { id: '717fae39-bca4-4637-8e18-b203024ff3f2' },
      { id: '717fae39-bca4-4637-8e18-b203024ff3f2', x: 2.875, y: 3.3125 }
    ],
    origin: [0.5, 0.5],
    repeat: [[5.75, 0], [0, 6.625]]
  },

  'ce3a0a56-e73f-4f8c-bc6c-3c98453ce58f': {
    name: 'Scale Large',
    dimensions: {
      i: `W 11 1/8” x H 11 7/16”`,
      m: 'W 28.3 cm x H 29 cm',
      w: 28.3,
      h: 29
    },
    fullBlocksOnly: true,
    blocks: [
      { id: 'c52c3cb4-390b-4cac-9ff3-f601c7439369' },
      { id: 'c52c3cb4-390b-4cac-9ff3-f601c7439369', x: 5.75, y: 6.5 }
    ],
    origin: [0.5, 0.5],
    repeat: [[11.4375, 0], [0, 13]]
  },

  'd45ca39c-774f-11ee-b962-0242ac120002': {
    name: 'Twill',
    // blocks: [{ id: '44ff1abc-7750-11ee-b962-0242ac120002'}, ],
    dimensions: {
      i: `W 12" x H 12"`,
      m: 'W 30.5 cm x H 30.5 cm',
      w: 30.5,
      h: 30.5,
    },
    blocks: [
      { id: '1342419c-78c8-11ee-b962-0242ac120002' }, 
      { id: '7657f05e-78c5-11ee-b962-0242ac120002' }, 
      { id: 'b8701284-7751-11ee-b962-0242ac120002', x: 2 },
      { id: '44ff1abc-7750-11ee-b962-0242ac120002' },
    ],
    origin: [0, 0],
    repeat: [[24, 0], [0, 24]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    calcTileCountWithDimensions: true,
  },
  'fe8f7952-99d5-11ee-b9d1-0242ac120002': {
    name: 'Gingham',
    dimensions: {
      i: `W 12" x H 12"`,
      m: 'W 30.5 cm x H 30.5 cm',
      w: 30.5,
      h: 30.5,
    },
    blocks: [
      { id: 'fe8f7de4-99d5-11ee-b9d1-0242ac120002' }, 
      { id: 'fe8f7f38-99d5-11ee-b9d1-0242ac120002' }, 
      { id: 'fe8f8258-99d5-11ee-b9d1-0242ac120002' }, 
    ],
    origin: [0, 0],
    repeat: [[12, 0], [0, 12]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    calcTileCountWithDimensions: true,
  },
  'fe8f8384-99d5-11ee-b9d1-0242ac120002': {
    name: 'Checker',
    dimensions: {
      i: `W 12" x H 12"`,
      m: 'W 30.5 cm x H 30.5 cm',
      w: 30.5,
      h: 30.5,
    },
    blocks: [
      { id: '5bfd32ea-99ff-11ee-b9d1-0242ac120002' }, 
      { id: 'a70a230e-99e8-11ee-b9d1-0242ac120002' }, 
      { id: 'a70a220a-99e8-11ee-b9d1-0242ac120002' }, 
      { id: 'a70a20f2-99e8-11ee-b9d1-0242ac120002' }, 
      { id: 'a70a1dfa-99e8-11ee-b9d1-0242ac120002' }, 
      { id: 'a70a1bac-99e8-11ee-b9d1-0242ac120002' }, 
    ],
    origin: [0, 0],
    repeat: [[12, 0], [0, 96]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    wallHeight: 108,
    calcTileCountWithDimensions: true,
    showColorsByName: true,
    patternRepeatHeight: 108,
  },
  '5bfd3664-99ff-11ee-b9d1-0242ac120002': {
    name: 'Waffle',
    dimensions: {
      i: `W 12" x H 12"`,
      m: 'W 30.5 cm x H 30.5 cm',
      w: 30.5,
      h: 30.5,
    },
    blocks: [
      { id: '5bfd37a4-99ff-11ee-b9d1-0242ac120002' }, 
      { id: '5bfd38c6-99ff-11ee-b9d1-0242ac120002' }, 
      { id: '5bfd39de-99ff-11ee-b9d1-0242ac120002' }, 
      { id: 'a2be56a6-9aa3-11ee-b9d1-0242ac120002' }, 
    ],
    origin: [0, 0],
    repeat: [[24, 0], [0, 24]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    calcTileCountWithDimensions: true,
  },
  'a2be58a4-9aa3-11ee-b9d1-0242ac120002': {
    name: 'Weave',
    dimensions: {
      i: `W 12" x H 12"`,
      m: 'W 91.5 cm x H 91.5 cm',
      w: 91.5,
      h: 91.5,
    },
    blocks: [
      { id: 'a2be5e08-9aa3-11ee-b9d1-0242ac120002' }, 
      { id: 'a2be5f3e-9aa3-11ee-b9d1-0242ac120002' }, 
      { id: '0874ca76-9ac6-11ee-b9d1-0242ac120002' }, 
      { id: '0874cd1e-9ac6-11ee-b9d1-0242ac120002' }, 
      { id: '0874d1ce-9ac6-11ee-b9d1-0242ac120002' }, 
      { id: '0874d304-9ac6-11ee-b9d1-0242ac120002' }, 
      { id: 'a2be59bc-9aa3-11ee-b9d1-0242ac120002' }, 
    ],
    origin: [0, 0],
    repeat: [[36, 0], [0, 36]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    calcTileCountWithDimensions: true,
  },
  'a72e6515-aa20-42db-b4fc-20a76e9d1d6e': {
    name: 'Mosaik',
    dimensions: {
      i: `W 12" x H 12"`,
      m: 'W 30.5 cm x H 30.5 cm',
      w: 30.5,
      h: 30.5,
    },
    blocks: [
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506500' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506501' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506502' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506503' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506504' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506505' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506506' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506507' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506508' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506509' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506510' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506511' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506512' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506513' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506514' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506515' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506516' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506517' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506518' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506519' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506520' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506521' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506522' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506523' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506524' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506525' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506526' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506527' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506528' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506529' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506530' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506531' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506532' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506533' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506534' }, 
      { id: 'ff70ca03-ff13-47f4-b05c-af6abf506535' }, 
    ],
    origin: [0, 0],
    repeat: [[12, 0], [0, 12]],
    align: [[12, 0, 0, -6]],
    showInches: false,
    showMetric: false,
    showFill: false,
    calcTileCountWithDimensions: true,
    customHelpNote: `Mosaik's design tool is set up for repeating 12" square tiles (six 2" tiles wide and high). Start building a pattern in the upper right-hand corner and the pattern will repeat automatically.`
  }
}



// WEBPACK FOOTER //
// ./src/universal/filzfelt/patterns.js